// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"87a85de5","225":"bb90cb65","344":"40102633","372":"6fac76dd","377":"bd94f0dd","521":"e81f6c3b","573":"78ed20f3","738":"b7824a45","841":"badf90e9","856":"1d50fe00","858":"80a50d58"}[chunkId] + ".chunk.js";
};